import React from 'react';
import { func, arrayOf, number, object } from 'prop-types';
import { styled } from '@mui/material/styles';
import { tabBarPadding } from '../../internals/page-layout/contentPadding';
import SovosTabs from '../../sovos-tabs';
import SovosTab from '../../sovos-tab';
const Root = styled(SovosTabs)(_ref => {
  let {
    theme: {
      breakpoints,
      palette,
      spacing
    }
  } = _ref;
  return {
    ...tabBarPadding(breakpoints, spacing),
    backgroundColor: palette.background.default,
    padding: "0 ".concat(spacing(2)),
    zIndex: 20
  };
});
const TabBar = _ref2 => {
  let {
    onTabClick,
    selectedTab,
    tabsData
  } = _ref2;
  function renderTab(tab, index) {
    return /*#__PURE__*/React.createElement(SovosTab, {
      key: "Tab".concat(index, "-").concat(tab.label),
      icon: tab.icon,
      label: tab.label,
      value: index
    });
  }
  return /*#__PURE__*/React.createElement(Root, {
    className: "sovosPageLayout__tabBar",
    onChange: onTabClick,
    value: selectedTab
  }, tabsData.map(renderTab));
};
TabBar.propTypes = {
  onTabClick: func.isRequired,
  selectedTab: number.isRequired,
  tabsData: arrayOf(object).isRequired
};
export default TabBar;